import { AgencyUserCrudValues} from '../store/InitialStore';
import * as types from '../actions/ActionTypes';
export default function AgencyUserForm(state = AgencyUserCrudValues,action){
    const {type,payload} = action;
    switch(type){         
        case types.SET_AGENCY_USER_PROFILE_PICTURE :
            return {
                ...state,
                profileImage : payload
            }     
        default:
            return state;
    }
}
